import { render, staticRenderFns } from "./checkinput.vue?vue&type=template&id=1cb8887b&"
import script from "./checkinput.vue?vue&type=script&lang=js&"
export * from "./checkinput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports